import { createContext, useContext, useEffect, useState } from "react";
import { userApi, formatApiErrorDetail } from "../lib/api";

const UserAuthContext = createContext(null);

export function UserAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("bilgece_user_token");
    if (!token) { setUser(false); setReady(true); return; }
    userApi.get("/auth/user-me")
      .then(({ data }) => setUser(data))
      .catch(() => { localStorage.removeItem("bilgece_user_token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const persist = (data) => { localStorage.setItem("bilgece_user_token", data.access_token); setUser(data.user); };

  const login = async (email, password) => {
    try { const { data } = await userApi.post("/auth/user-login", { email, password }); persist(data); return { ok: true }; }
    catch (e) { return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) }; }
  };
  const register = async (payload) => {
    try { const { data } = await userApi.post("/auth/register", payload); persist(data); return { ok: true }; }
    catch (e) { return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) }; }
  };
  const logout = () => { localStorage.removeItem("bilgece_user_token"); setUser(false); };
  const refresh = async () => { try { const { data } = await userApi.get("/auth/user-me"); setUser(data); } catch {} };

  return <UserAuthContext.Provider value={{ user, ready, login, register, logout, refresh, setUser }}>{children}</UserAuthContext.Provider>;
}

export const useUser = () => useContext(UserAuthContext);
